import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  return <section className="py-24 px-6" data-id="element-28">
      <div className="max-w-5xl mx-auto" data-id="element-29">
        <div className="grid md:grid-cols-2 gap-12 md:gap-8" data-id="element-30">
          <FadeIn direction="right" data-id="element-31">
            <h3 className="font-serif text-2xl mb-8 text-[#1C1917] flex items-center gap-3" data-id="element-32">
              <span className="w-8 h-8 rounded-full bg-[#E8F0E8] text-[#4A634A] flex items-center justify-center text-sm" data-id="element-33">
                ✓
              </span>
              Para quién es esto
            </h3>
            <ul className="space-y-6" data-id="element-34">
              {['Profesionales con agendas saturadas que no tienen tiempo para retiros espirituales.', 'Padres y madres que sienten que el caos doméstico los desborda desde temprano.', "Emprendedores que sufren de 'parálisis por análisis' y rumiación nocturna.", 'Cualquier persona que quiera despertar con enfoque y dormir con paz real.'].map((text, i) => <li key={i} className="flex gap-4" data-id="element-35">
                  <Check className="w-5 h-5 text-[#4A634A] shrink-0 mt-1" strokeWidth={2} data-id="element-36" />
                  <span className="text-[#4A4541] text-lg" data-id="element-37">{text}</span>
                </li>)}
            </ul>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-38">
            <h3 className="font-serif text-2xl mb-8 text-[#1C1917] flex items-center gap-3" data-id="element-39">
              <span className="w-8 h-8 rounded-full bg-[#F2E8E8] text-[#8C4A4A] flex items-center justify-center text-sm" data-id="element-40">
                ✕
              </span>
              Para quién NO es
            </h3>
            <ul className="space-y-6" data-id="element-41">
              {['Personas que buscan una solución mágica sin dedicar 5 minutos de práctica real.', 'Usuarios que prefieren teorías místicas largas sobre protocolos prácticos.', 'Quienes no estén dispuestos a dejar el teléfono móvil lejos de la cama.'].map((text, i) => <li key={i} className="flex gap-4" data-id="element-42">
                  <X className="w-5 h-5 text-[#8C4A4A] shrink-0 mt-1" strokeWidth={2} data-id="element-43" />
                  <span className="text-[#4A4541] text-lg" data-id="element-44">{text}</span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}